import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../services/user.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  constructor(private mRouter: Router, private mUserService: UserService) {
  }

  ngOnInit(): void {
    this.mUserService.getUser().subscribe(r => {
      if (r) {
        if (window.location.pathname == '/') {
          this.mRouter.navigate(['/dashboard']);
        }
      } else {
        this.mRouter.navigate(['/login']);
      }
    });
  }
}
